import { Space } from "antd";

import Input from "../CommonCommponents/Input";
import Select from "../CommonCommponents/select/Select";
import { CURRENCY_CODES } from "../../Utils/constants";

const { Compact } = Space;

export default function CTCField({ control }) {

  const formattedCurrencyOptions = CURRENCY_CODES.map((currency) => ({
    value: currency.value, // Should correctly map to the value
    label: `${currency.symbol} (${currency.value})`,
  }));
  
  console.log(formattedCurrencyOptions); // Debugging: Check the output
  
  
  return (
    <Compact >
      <Select
        allowClear
        showArrow={false}
        control={control}
        options={formattedCurrencyOptions} 
        name={"ctc_currency_code"}
        label={<p className="mr-4 ctc_div">Currency Code</p>}
      />
      <Input
        control={control}
        name={"current_ctc"}
     
        placeholder={"Eg. 400,000"}
        label={<p className="mr-4 ctc_div"   >Total Annual Salary</p>}
        rules={{
          required: "This field is required",
          pattern: {
            value: /^[0-9]+$/,
            message: "Please use numbers only",
          },
        }}
      />
      <Input
        control={control}
        name={"expected_ctc"}
        placeholder={"Eg. 400,000"}
        label={<p className="mr-4 ctc_div">Expected Annual Salary</p>}
        rules={{
          required: "This field is required",
          pattern: {
            value: /^[0-9]+$/,
            message: "Please use numbers only",
          },
        }}
      />
    </Compact>
  );
}
